import axios from 'axios'
import {
  get,
  post,
  del
} from '@/http/request'
import {
  HOST
} from '@/http/config'


//同步人事花名册
export function sysPersonnel(params) {
  return get(`${HOST}sys-user/sysPersonnel`, params)
}
// 新增用户
export function addUser(params) {
  return post(`${HOST}sys-user/save`, params)
}
// 修改用户
export function updateUser(params) {
  return post(`${HOST}sys-user/update`, params)
}
// 启用禁用用户
export function updateStatus(params) {
  return post(`${HOST}sys-user/updateStatus`, params)
}
//用户列表
export function getUser(params) {
  return get(`${HOST}sys-user/list`, params)
}
//用户列表 人员主送
export function getNewUser(params) {
  return get(`${HOST}sys-user/list-new`, params)
}
//用户详情
export function getUserDetails(params) {
  return get(`${HOST}sys-user/detatils`, params)
}
//重置密码
export function resetPassword(params) {
  return get(`${HOST}/sys-user/resetPassword`, params)
}
//根据名字搜索用户
export function queryList(params) {
  return get(`${HOST}sys-user/queryList`, params)
}
//组织结构树
export function getTreeList(params) {
  return get(`${HOST}organization-info/treeList/`, params)
}
//组织结构详情
export function getOrganizationDetail(params) {
  return get(`${HOST}organization-info/detail`, params)
}
//新建组织结构
export function addOrganization(params) {
  return post(`${HOST}organization-info/add`, params)
}
//修改组织结构
export function updateOrganization(params) {
  return post(`${HOST}organization-info/updateById`, params)
}
//组织结构启用禁用
export function updateOrganizationEnableNum(params) {
  return post(`${HOST}organization-info/updateOrganizationEnableNumById`, params)
}
//获取业务列表
export function getAppList() {
  return get(`${HOST}app-info/list/`)
}
//获取权限列表
export function getRoleList(params) {
  return get(`${HOST}sys-role/list/`, params)
}
//添加权限
export function addRole(params) {
  return post(`${HOST}sys-role/addRole`, params)
}
//修改权限
export function updateRole(params) {
  return post(`${HOST}sys-role/updateRole`, params)
}
// 删除权限
export function delRole(params) {
  return del(`${HOST}sys-role/deleteById`, params)
}
//权限启用禁用
export function updateRoleEnableNumById(params) {
  return post(`${HOST}sys-role/updateRoleEnableNumById`, params)
}
//获取菜单列表
export function getMenuList(params) {
  return get(`${HOST}sys-menu/list`, params)
}
//根据类型查询字典下拉列表
export function listByType(params) {
  return get(`${HOST}sys-dict/listByType`, params)
}
//获取分组列表
export function getGroupList(params) {
  return get(`${HOST}sys-group/list`, params)
}
//获取全部部门
export function getOrgIds() {
  return get(`${HOST}sys-group/getOrgIds`)
}
//添加分组
export function addGroup(params) {
  return post(`${HOST}sys-group/save`, params)
}
//修改分组
export function updateGroup(params) {
  return post(`${HOST}sys-group/update`, params)
}
// 删除分组
export function delGroup(params) {
  return post(`${HOST}sys-group/delete`, params)
}
//获取分组详情
export function getGroupDetial(params) {
  return get(`${HOST}sys-group/get`, params)
}
//获取分组详情
export function getoperationLog(params) {
  return post(`${HOST}operation-log/list/`, params)
}

//获取提醒设置
export function gettiming(params) {
  return get(`${HOST}timing/get`, params)
}
//修改提醒设置
export function updatetiming(params) {
  return post(`${HOST}timing/update`, params)
}

//获取部门用户合并树
export function getOrganizationList(params) {
  return get(`${HOST}sys-send/organizationList`, params)
}
// 新增获取部门用户合并树
export function getsOrganizationListNew(params) {
  return get(`${HOST}sys-send/organizationListNew?name=${params}`)
}

//获取人员分组列表
export function getSendList(params) {
  return get(`${HOST}sys-send/list`, params)
}
//添加人员分组
export function addSend(params) {
  return post(`${HOST}sys-send/save`, params)
}
//修改人员分组
export function updateSend(params) {
  return post(`${HOST}sys-send/update`, params)
}
// 删除人员分组
export function delSend(params) {
  return del(`${HOST}sys-send/delete`, params)
}


//系统人员权限列表
export function PermissionsxList(params) {
  return get(`${HOST}Permissionsx/list/`, params)
}

//短信机构部门树
export function smsTreeList(params) {
  return get(`${HOST}organization-sms/treeList`, params)
}
//根据id修改状态以及时间
export function smsUpdateRoleEnableNumById(params) {
  return post(`${HOST}organization-sms/updateRoleEnableNumById`, params)
}

// 机构业务权限配置复选框
export function organizationBusiness(params) {
  return get(`${HOST}sys-menu/listLevel`, params)
}

// 权限列表 新
export function getOrganizationRoleMenu(params) {
  return post(`${HOST}sys-role/getOrganizationRoleMenu`, params)
}

// 报销比例设置列表
export function reimbursementRateList(params) {
  return get(`${HOST}reimbursement-type/list`, params)
}

// 修改 报销比例设置列表数据
export function updateReimbursementRateList(params) {
  return post(`${HOST}reimbursement-type/update`, params)
}


/**
 * 短信分组列表接口
 */
//获取短信分组列表
export function getSMSGroupList(params) {
  return get(`${HOST}sms-group/list`, params)
}

//添加短信分组
export function addSMSGroup(params) {
  return post(`${HOST}sms-group/save`, params)
}

//修改短信分组
export function updateSMSGroup(params) {
  return post(`${HOST}sms-group/update`, params)
}

// 删除分组
export function delSMSGroup(params) {
  return del(`${HOST}sms-group/delete`, params)
}

//短信分组列表接口end//
// 删除分组
export function getSysPersonnelState(params) {
  return get(`${HOST}sys-user/getSysPersonnelState`, params)
}

//带分页
export function queryListPage(params) {
  return get(`${HOST}sys-user/queryListPage`, params)
}



// WEBPACK FOOTER //
// ./src/views/system/api/api.js